import { render, staticRenderFns } from "./TenderListBreakdown.vue?vue&type=template&id=453b5128&"
import script from "./TenderListBreakdown.vue?vue&type=script&lang=js&"
export * from "./TenderListBreakdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports